import React from 'react';
import PropTypes from 'prop-types';
import NextLink from 'next/link';
import { useTranslations } from 'next-intl';
import track from '@helper/tracking';
import MixedCopy from '../mixed-copy/mixedCopy';
import Copy from '../../atoms/copy/copy';

const StickyContainer = ({ address, relevantLinks, toursFreeEntrance }) => {
  const t = useTranslations();

  return (
    <div className="current-info__fixed-container">
      <div className="current-info__fixed">
        {toursFreeEntrance && (
          <div className="current-info__item">
            <div className="current-info__icon">
              <img
                height={40}
                width={40}
                src="/static/svg/current-info/ticket.svg"
                alt={`${t('entry')} – Icon`}
              />
            </div>
            <div className="current-info__item-copy">
              <MixedCopy html={toursFreeEntrance} />
            </div>
          </div>
        )}
        {address && (
          <div className="current-info__item">
            <div className="current-info__icon">
              <img
                height={40}
                width={40}
                src="/static/svg/current-info/sneaker.svg"
                alt={`${t('addressInformation')} – Icon`}
              />
            </div>
            <div className="current-info__item-copy">
              <Copy>
                {`${address.street ?? ''}, ${address.zipcode ?? ''} ${address.city ?? ''}`}
                <br />
                {address.phone ?? ''}
              </Copy>
            </div>
          </div>
        )}
        {relevantLinks && relevantLinks.length > 0 && (
          <div className="current-info__item">
            <div className="current-info__icon">
              <img
                height={40}
                width={40}
                src="/static/svg/current-info/marker.svg"
                alt={`${t('visitInstructions')} – Icon`}
              />
            </div>
            <div className="current-info__item-copy">
              <Copy>
                {relevantLinks.map(link => {
                  if (!link.url || !link.title) {
                    return null;
                  }
                  return (
                    <>
                      <NextLink
                        key={link.id}
                        href={link.url}
                        target="_blank"
                        onClick={() => {
                          track(['trackEvent', 'route', 'Click', link.url]);
                        }}
                        aria-label={`${t('learnMoreAbout')}"${link.title}"`}
                      >
                        {link.title}
                      </NextLink>
                      <br />
                    </>
                  );
                })}
              </Copy>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

StickyContainer.propTypes = {
  address: PropTypes.shape({
    street: PropTypes.string,
    zipcode: PropTypes.string,
    city: PropTypes.string,
    phone: PropTypes.string
  }),
  relevantLinks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ),
  toursFreeEntrance: PropTypes.string
};

export default StickyContainer;
